/**
 * Provides UI for display of a collection of `Document` models contained in a `DocumentCollection`.
 * ## Fields
 * Name | Description
 * --- | ---
 * table | The underlying `CollectionTableView` used to display the models.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * folder-select | The `Document` representing the directory that was selected. | Fires when a directory-type `Document` is selected.
 * @module app/views/DirectoryView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import ModalView from "core/views/ModalView";
import CollectionTableView from "core/views/CollectionTableView";
import Field from "core/models/Field";
import Document from "app/models/Document";
import ErrorUtils from "app/utils/ErrorUtils";
import isMobile from "core/is-mobile";
import messenger from "app/Messenger";
export default Backbone.View.extend({
  className: "directory-view",

  events: {
    "click .folder-select": function (evt) {
      var el = $(evt.target);

      this.trigger(
        "folder-select",
        this.options.collection.get(el.data("doc-id"))
      );
    },
  },

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {DocumentCollection} options.collection The collection of `Document` models to display.
   * @param {Boolean} options.allowEdit True to allow modification and removal of models.
   * @param {Field} options.linkField The field to use to display a link for the file/directory.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options);

    var fields = [
      new Field(
        _.extend(Document.fields["Name"], {
          editable: this.options.allowEdit ? true : false,
        })
      ),
    ];

    fields.push(this.options.linkField);

    this.table = new CollectionTableView({
      fields: fields,
      collection: this.options.collection,
      allowSave: this.options.allowEdit,
      allowDelete: this.options.allowEdit,
      // mode: this.options.allowEdit ? '' : 'view'
    });

    this.table.on("row-commit", this._doCommit, this);
    this.table.on("row-delete", this._doRemove, this);
  },

  _doCommit: function (row) {
    row.model.save();
    row.edit(false);
    row.render();
  },

  _doRemove: function (row) {
    if (row.model.isNew()) {
      row.model.destroy();
      row.remove();
    } else {
      var prompt;
      var title;
      var deleteConfirmText;

      if (row.model.get("IsFolder")) {
        prompt =
          "Are you sure you want to remove this folder? Any contents will also be permanently deleted.";
        title = "Delete Folder";
        deleteConfirmText = "Folder deleted.";
      } else {
        prompt = "Are you sure you want to remove this file?";
        title = "Delete File";
        deleteConfirmText = "File deleted.";
      }

      var deleteConfirmation = new ModalView({
        title: title,
        buttons: [
          {
            text: "Cancel",
            click: function () {
              deleteConfirmation.remove();
            },
          },
          {
            text: "Delete",
            type: "danger",
            click: function () {
              row.model.destroy({
                success: function () {
                  deleteConfirmation.remove();
                  messenger.success(deleteConfirmText);
                  row.remove();
                },
                error: ErrorUtils.apiHandler({
                  cleanUp: function () {
                    deleteConfirmation.remove();
                  },
                  activity: "deleting the file",
                }),
              });
            },
          },
        ],
      });

      deleteConfirmation.render();
      deleteConfirmation.setContent(prompt);
      deleteConfirmation.show();
    }
  },

  render: function () {
    this.table.render();

    if (isMobile) {
      this.$el.append('<p class="help-block">Tap to rename</p>');
    }

    this.$el.append(this.table.$el);
  },

  delegateEvents: function () {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);
    this.table.delegateEvents();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/DirectoryView.js
// module id = 896
// module chunks = 1